
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as SaleServiceModels from '../../models/sale-service/sale-service';
import { EnvironmentService } from '../../../app/services/environment.service';
import { SaleServiceSearchModel } from '../../models/sale-service/sale-serviceSearch';
import { SpecificationListSummaryModel } from '../../models/specification/specification';

@Injectable({
  providedIn: 'root'
})

export class SaleServiceService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public get(Search: SaleServiceSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<SaleServiceModels.SaleServiceListModel>(`${this.environmentService.getApiURL()}/sale/service/list`, Search, options);
  }

  public getSummary(Search: SaleServiceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<SpecificationListSummaryModel>(
      `${this.environmentService.getApiURL()}/sale/service/list/summary`, Search, options
      );
  }

  public getFilteredReport(Search: SaleServiceSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/sale/service/report/filtered`, Search, options);

  }


}
